<template>
  <div class="index-module_articleWrap_2Zphx">
      <p class="zhemo">
          价值投资概念的白话解读
        </p>
        <p  class="text_content">
          价值投资和炒股票，虽然买的都是股票，但是实际上有完全不同的交易理念。
        </p>
        <p class="text_content">
          炒股票是一种投机行为，通过判断股票价格的上涨趋势，在上涨趋势开始阶段买入，在股票价格未来高位时卖出，赚取买卖价差。炒股票风险是很高的，一旦判断错误高点接盘，不管是套牢还是割肉出局，都是投资者不想看到但是又无法避免的结局。
        </p>
        <p class="text_content">
          价值投资是一种投资行为，通过分析上市公司的质地来判断股票的价值，这只股票到底值多少钱，价格低于股票价值时买入，一旦买入就拥有了和股票数量对应的企业所有权，作为股东长期持有，分享企业成长带来的收益。价值投资可能不会短时间内暴利，但是风险是很低的，因为是低位买入，股票价格是围绕价值波动的，长期看风险极低的。
        </p>
        <p class="text_content">
          价值投资和炒股票相比，最大的区别是思维视角不一样。价值投资考虑的不是能不能赚钱，而是坚持低位买入来保证不亏钱。
        </p>
        <p class="text_content">
          wh5以上述原则为基础，对A股上市企业进行了深度的挖掘和整理，提供专业化价值判断工具：EVA分析、利润滤镜、风险甄别等功能一一提供盈利质量和财务风险分析，规避投资风险；主营构成、行业地位、财务透视等功能一一提供经营状况、资产和盈利透视分析，快速形成和扩大能力圈；价值分析、机构预测等功能一一提供基本面定价模型，确定估值水平和安全边际。
        </p>
        <p class="free">（原创）</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

  .service_content{
    width: 990px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0 0 20px -5px #ccc; 
    min-height: 600px;
    padding-bottom: 50px;
  }
  .service_content .title{
    color: #5f5f5f;
    border-bottom: 1px dashed #a8a8a8;
    line-height: 40px;
    font-size: 22px;
  }
  .text_content{
    text-indent: 2em;
    font-size: 14px;
    line-height: 20px;
    color:#6f6f6f;
    padding: 10px 0;
    text-align: justify;
  }
  .title2{
    font-size: 16px;
    color: #5d0f0b;
    border-left: 4px solid #e24a49;
    font-weight: bold;
    padding-left: 10px;
    margin: 15px 0;
  }
</style>